import { componentStyle } from '@/styling/util/component-style.ts';
import type { RadioButtonDesignTokens } from '@primeuix/themes/types/radiobutton';

// Copied radio button relevant design tokens form primevue material
// https://github.com/primefaces/primevue/blob/master/packages/themes/src/presets/material/base/index.js
// https://github.com/primefaces/primevue/blob/master/packages/themes/src/presets/material/radiobutton/index.js

const formField = {
    borderRadius: '{border.radius.sm}',
    transitionDuration: '{transition.duration}',
    background: '{surface.0}',
    disabledBackground: '{surface.100}',
    filledBackground: '{surface.100}',
    borderColor: '{surface.400}',
    hoverBorderColor: '{surface.900}',
    focusBorderColor: '{primary.color}',
    invalidBorderColor: '{red.800}',
    color: '{surface.900}',
    disabledColor: '{surface.600}',
    shadow: 'none',
};

export const radioButtonStyle = componentStyle<RadioButtonDesignTokens>({
    root: {
        width: '20px',
        height: '20px',
        background: formField.background,
        checkedBackground: '{primary.contrast.color}',
        checkedHoverBackground: '{primary.contrast.color}',
        disabledBackground: formField.disabledBackground,
        filledBackground: formField.filledBackground,
        borderColor: formField.borderColor,
        hoverBorderColor: formField.hoverBorderColor,
        focusBorderColor: formField.focusBorderColor,
        checkedBorderColor: '{primary.color}',
        checkedHoverBorderColor: '{primary.color}',
        checkedFocusBorderColor: '{primary.color}',
        checkedDisabledBorderColor: formField.borderColor,
        invalidBorderColor: formField.invalidBorderColor,
        shadow: formField.shadow,
        focusRing: {
            width: '0',
            style: 'none',
            color: 'unset',
            offset: '0',
            shadow: 'none',
        },
        transitionDuration: formField.transitionDuration,
        sm: {
            width: '16px',
            height: '16px',
        },
        lg: {
            width: '24px',
            height: '24px',
        },
    },
    icon: {
        size: '10px',
        checkedColor: '{primary.color}',
        checkedHoverColor: '{primary.color}',
        disabledColor: formField.disabledColor,
        sm: {
            size: '8px',
        },
        lg: {
            size: '12px',
        },
    },
});
